// /settings/mailing — «Рассылка» (033: T011, T012; FR-001, FR-002, FR-007, FR-008; ASG-NTF-11):
// режим установки и адреса песочницы (settings.write — администратор клиента), «Опасная зона»
// со стоп-краном (mail.stop — администратор клиента и контролёр). Раздел виден с любым из двух
// прав; остальным — «Нет доступа» с кодом сервера.
import { createFileRoute } from '@tanstack/react-router';
import { MailingSettingsPage } from '../../../features/settings/mailing/MailingSettingsPage.tsx';
import { requireSection } from '../../../shell/permissions.ts';

export const Route = createFileRoute('/_app/_settings/settings/mailing')({
  beforeLoad: requireSection('mailing'),
  staticData: { crumb: 'Рассылка' },
  component: MailingSettingsPage,
});
